
import { defineComponent } from 'vue';

export default defineComponent({
  name: `Version`,
  data: () => ({
    version: require(`../../package.json`).version,
  }),
});
